import React from 'react';
import { useTranslator } from '../../../i18n/useTranslator';
import { Popover } from '@milanote/roma';
import { cx } from '@milanote/roma/utils';

const styles = {
    sm: {
        inputSize: 'md',
    },
    lg: {
        inputSize: 'lg',
    },
} as const;

type BoardLinkSearchBarProps = {
    onQueryChange: (value: string) => void;
    autoFocus: boolean;
    query?: string;
    className?: string;
    size?: keyof typeof styles;
};

const BoardLinkSearchBar: React.FC<BoardLinkSearchBarProps> = ({
    query,
    onQueryChange,
    autoFocus,
    className,
    size = 'sm',
}) => {
    const translate = useTranslator('popup', 'boardLink.search');
    const sizeStyles = styles[size];

    return (
        <Popover.Header className={cx('BoardLinkSearchBar border-b-0 pb-0', className)}>
            <Popover.Search
                aria-label={translate('placeholder')}
                name="board-link-search-input"
                placeholder={translate('placeholder')}
                size={sizeStyles.inputSize}
                value={query ?? ''}
                onChange={onQueryChange}
                autoFocus={autoFocus}
            />
        </Popover.Header>
    );
};

export default BoardLinkSearchBar;
